// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-5933137a] {\n  padding: 0;\n}\n.container[data-v-5933137a] {\n  color: black;\n  margin-bottom: 20px;\n}\n.container .field[data-v-5933137a] {\n  font-weight: 600;\n}\n.container .info[data-v-5933137a] {\n  position: relative;\n  top: -8px;\n  left: 4px;\n  color: #cccccc;\n  font-size: 14px;\n}\n[data-v-5933137a] .el-dialog__body {\n  padding: 5px 30px 20px 30px;\n}\n[data-v-5933137a] .el-dialog__body .el-checkbox {\n  padding: 5px;\n}", ""]);
// Exports
module.exports = exports;
